<template>
    <div>
        <kgr-drop-file
            :custom-id="customId"
            :multiple="multiple"
            :show-size="showSize"
            :jpg-only="jpgOnly"
            :jpg-png-only="jpgPngOnly"
            :jpg-png-gif-only="jpgPngGifOnly"
            :jpg-png-gif-bmp-only="jpgPngGifBmpOnly"
            :pdf-only="pdfOnly"
            :max-file-size="maxFileSize"
            :max-total-size="maxTotalSize"
            emit-files
            @files="changeFiles"
        />
        <div ref="default">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import DropFile from './DropFile.vue';

export default {
    compatConfig: {
        MODE: 3,
    },

    name: 'DropFileWrapper',
    components: {
        'kgr-drop-file': DropFile,
    },
    props: {
        customId: {
            type: String,
            required: false,
            default: null,
        },
        multiple: {
            type: Boolean,
            required: false,
            default: false,
        },
        showSize: {
            type: Boolean,
            required: false,
            default: false,
        },
        jpgOnly: {
            type: Boolean,
            required: false,
            default: false,
        },
        jpgPngOnly: {
            type: Boolean,
            required: false,
            default: false,
        },
        jpgPngGifOnly: {
            type: Boolean,
            required: false,
            default: false,
        },
        jpgPngGifBmpOnly: {
            type: Boolean,
            required: false,
            default: false,
        },
        pdfOnly: {
            type: Boolean,
            required: false,
            default: false,
        },
        maxFileSize: {
            type: Number,
            required: false,
            default: null,
        },
        maxTotalSize: {
            type: Number,
            required: false,
            default: null,
        },
    },
    methods: {
        changeFiles(changedFiles) {
            const input = this.$refs.default.querySelector('input[type="file"]');

            const dataTransfer = new DataTransfer();
            changedFiles.forEach((changedFile) => {
                dataTransfer.items.add(changedFile);
            });
            if (this.multiple) {
                input.name = input.name.replace('[][]', '[]');
            }
            input.files = dataTransfer.files;

            const ev = new Event('change', { bubbles: true });
            input.dispatchEvent(ev);
        },
    },
};
</script>

<style scoped lang="scss">
</style>
